module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "开始时间"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "value-format": "yyyy-MM-dd",
      "type": "date",
      "placeholder": "选择日期"
    },
    model: {
      value: (_vm.filters.entimes),
      callback: function($$v) {
        _vm.$set(_vm.filters, "entimes", $$v)
      },
      expression: "filters.entimes"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "结束时间"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "value-format": "yyyy-MM-dd",
      "type": "date",
      "placeholder": "选择日期"
    },
    model: {
      value: (_vm.filters.entimee),
      callback: function($$v) {
        _vm.$set(_vm.filters, "entimee", $$v)
      },
      expression: "filters.entimee"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "广告平台"
    }
  }, [_c('el-select', {
    staticClass: "h-m-select",
    attrs: {
      "filterable": "",
      "placeholder": "选择广告平台"
    },
    model: {
      value: (_vm.filters.scode),
      callback: function($$v) {
        _vm.$set(_vm.filters, "scode", $$v)
      },
      expression: "filters.scode"
    }
  }, _vm._l((_vm.splist), function(item) {
    return _c('el-option', {
      key: item.scode,
      attrs: {
        "label": item.sname
      },
      model: {
        value: (item.scode),
        callback: function($$v) {
          _vm.$set(item, "scode", $$v)
        },
        expression: "item.scode"
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    staticClass: "h-m-select",
    attrs: {
      "filterable": "",
      "placeholder": "请选择渠道"
    },
    model: {
      value: (_vm.filters.cpcode),
      callback: function($$v) {
        _vm.$set(_vm.filters, "cpcode", $$v)
      },
      expression: "filters.cpcode"
    }
  }, _vm._l((_vm.cplist), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name
      },
      model: {
        value: (item.code),
        callback: function($$v) {
          _vm.$set(item, "code", $$v)
        },
        expression: "item.code"
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-checkbox', {
    model: {
      value: (_vm.filters.showtime),
      callback: function($$v) {
        _vm.$set(_vm.filters, "showtime", $$v)
      },
      expression: "filters.showtime"
    }
  }, [_vm._v("显示时间")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-checkbox', {
    model: {
      value: (_vm.filters.showspinfo),
      callback: function($$v) {
        _vm.$set(_vm.filters, "showspinfo", $$v)
      },
      expression: "filters.showspinfo"
    }
  }, [_vm._v("显示上游")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-checkbox', {
    model: {
      value: (_vm.filters.showcpinfo),
      callback: function($$v) {
        _vm.$set(_vm.filters, "showcpinfo", $$v)
      },
      expression: "filters.showcpinfo"
    }
  }, [_vm._v("显示渠道")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-checkbox', {
    model: {
      value: (_vm.filters.showsite),
      callback: function($$v) {
        _vm.$set(_vm.filters, "showsite", $$v)
      },
      expression: "filters.showsite"
    }
  }, [_vm._v("显示Site")])], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getLists
    }
  }, [_vm._v("搜索")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.clarnQuery
    }
  }, [_vm._v("清空条件")])], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "95%"
    },
    attrs: {
      "header-cell-style": {
        background: '#999999',
        color: '#000'
      },
      "data": _vm.datalist,
      "border": "",
      "stripe": "",
      "highlight-current-row": "",
      "height": "500",
      "summary-method": _vm.formatXxfUp,
      "show-summary": ""
    }
  }, [(_vm.filters.noShowColTable) ? _c('el-table-column', {
    attrs: {
      "label": "----",
      "min-width": "30"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.filters.showtimeTable) ? _c('el-table-column', {
    attrs: {
      "prop": "date",
      "label": "Daily",
      "min-width": "60"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.filters.showspinfoTable) ? _c('el-table-column', {
    attrs: {
      "prop": "spname",
      "label": "上游",
      "min-width": "60"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.filters.showcpinfoTable) ? _c('el-table-column', {
    attrs: {
      "prop": "cpname",
      "label": "渠道",
      "min-width": "60"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.filters.showsiteTable) ? _c('el-table-column', {
    attrs: {
      "prop": "site",
      "label": "site",
      "min-width": "100"
    }
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "requests",
      "label": "请求",
      "min-width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "pp_requests",
      "label": "填充",
      "min-width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "fill_rate",
      "label": "填充率",
      "min-width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "imp",
      "label": "展示",
      "min-width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "imp_rate",
      "label": "展示率",
      "min-width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "click",
      "label": "点击",
      "min-width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "ctr",
      "label": "CTR(%)",
      "min-width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "publisher_cpc",
      "label": "CPC",
      "min-width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "publisher_cpm",
      "label": "ECPM",
      "min-width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "net_revenue",
      "label": "分成前",
      "min-width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "publisher_revenue",
      "label": "分成后",
      "min-width": "60"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-9cf11704"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/views/adx/Rtreport9933.vue
// module id = 658
// module chunks = 1